namespace Gordic.Epk.WebControls {

    export class GEpkSouvisejiciVazby {

        /** data z řádku žádosti v epk */
        private epkRow: Gordic.Wfl.Interface.GPodpisovaKnihaDto;
        private subtasks: JQuery<HTMLElement>;
        private view: Gordic.Data.View<any>;
        private body: JQuery<HTMLElement>;
        private parentElement: JQuery<HTMLElement>;
        private main: JQuery<HTMLElement>;
        private cnt: GContentType<any>;
        private grid: JQuery<HTMLElement>;
        private attachment: JQuery<HTMLElement>;

        constructor(cnt: GContentType<any>, parentElement, epkRow: Gordic.Wfl.Interface.GPodpisovaKnihaDto) {
            this.cnt = cnt;
            this.parentElement = parentElement;
            this.epkRow = epkRow;
        }

        public create() {

            if (this.cnt.closed === true)
                return;

            this.init();
            this.main.gcover({ text: "jres:32000618..." }); //RC 32000618 : Probíhá načítání
            this.createSubtasks();

            this.loadData()
                .then((data: Wfl.Interface.GSouvisejiciDokumentyDto) => {
                    if (this.cnt.closed === true)
                        return;
                    var view: Gordic.Wfl.Interface.GSeznamSouvisejicichDokumentuDto[] = [];
                    if (data.SouvisejiciDokumenty != null)
                        view = data.SouvisejiciDokumenty;
                    this.view = new Gordic.Data.View(view);
                })
                .then(() => {
                    this.createGrid();  // výchozí spuštění akce
                })
                .done(() => {
                    if (this.cnt.closed === true)
                        return;
                    if (this.main != null && this.main.hasClass("gcover"))
                        this.main.gcover("destroy");
                })
        }

        private init() {
            this.main = $("<div>").appendTo(this.parentElement);
            this.subtasks = $("<div>").appendTo(this.main);
            this.body = $("<div>").appendTo(this.main);
        }

        private loadData() {

            var dfd = $.Deferred();
            var actionName = "Gordic.Wfl.Server.GEpkSouvisDokAsyncTask";
            var Ixp = this.epkRow.ixp;

            // ukončení async. úlohy pokud existovala
            Gordic.Async.GTaskManager.cancel(actionName);
            var asyncTask = Gordic.Async.GTaskManager.start<Gordic.Async.IGTaskProgress, any>(actionName, { pouzeAktivni: true, Ixp: Ixp });

            asyncTask
                .getPromise()
                .then((dto) => {
                    if (this.cnt.closed === true) { 
                        Gordic.Async.GTaskManager.cancel(asyncTask);
                        return;
                    }
                    dfd.resolve(dto.result);
                })
                .always(() => {
                    Gordic.Async.GTaskManager.clean(asyncTask);
                })

            return dfd.promise();
        }

        private createSubtasks() {
            var params: MenuParams[] = [];
            var kpi = {
                action: this.cnt.actions.add(new GAction({
                    id: "actSubtasksGrid",
                    name: "subtasksGrid",
                    caption: "jres:32000617",				//RC 32000617 : Seznam
                    run: () => {
                        this.createGrid();
                    }
                })),
            };
            params.push(kpi);
            var seznam = {
                action: this.cnt.actions.add(new GAction({
                    id: "actSubtasksAttachment",
                    name: "subtasksAttachment",
                    caption: "jres:32000616",				//RC 32000616 : Náhled
                    run: () => {
                        this.createAttachment();
                    }
                })),
            };
            params.push(seznam);
            this.subtasks.gsubtasks({ params: params });
        }

        private createGrid() {
            this.showPanel("grid");
            if (this.grid == null) {
                this.grid = $("<div>").appendTo(this.body);
                this.grid.gautofit({ parentElement: ".g-sbp-content" }).ggrid({
                    data: this.view,
                    columns: (Gordic as any).Wfl.GWflCommonDlg.getGridSouvisejiciDokumentKolonky(null, this.epkRow.typ_ag, this.epkRow.ixs_fun, true),
                    columnMode: "full",
                    defaultAction: new GAction({
                        name: "actDefault",
                        run: (ev, ctx) => {
                            var data = ctx.cellInfo.data;
                            var ixp = data.ixp_spis_2;
                            var options = {
                                DetailDto: { ixp: ixp },
                                EditMode: false,
                                grid: this.grid
                            };
                            Gordic.Wfl.Dialogs.DetailDokumentuSpisu(this.cnt, options, Gordic.Gin.Globals.Enums.ModOtevreni.navigate);
                        }
                    })
                });
            }
        }

        private showPanel(panel: "attachment" | "grid") {
            switch (panel) {
                case "attachment":
                    if (this.attachment != null) {
                        this.attachment.show();
                    }
                    if (this.grid != null) {
                        this.grid.hide();
                    }
                    break;
                case "grid":
                    if (this.attachment != null) {
                        this.attachment.hide();
                    }
                    if (this.grid != null) {
                        this.grid.show();
                    }
                    break;
            }
        }


        private tempIxp: string | null = null; 

        /**
         * getAttachmentIxp - vrať identifikátor souvisejícho souboru
         */
        private getAttachmentIxp() {

            if (this.grid == null)
                return null;

            // data souvisejících dokumentů
            var row = this.grid.ggrid("activeRow"); 

            if (row == null || row.ixp_vis == null)
                return null;

            // identifikátor souvisejícho souboru
            return row.ixp_vis;
        }

        private createAttachment() {

            this.showPanel("attachment");

            // identifikátor souvisejícho souboru
            var ixp_vis = this.getAttachmentIxp();

            if (ixp_vis != null) {
                if (this.tempIxp != ixp_vis) {

                    if (this.attachment != null) {
                        this.attachment.remove();
                    }
                    this.attachment = $("<div>").appendTo(this.body);

                    // nastavím nové temp id dokumentu
                    this.tempIxp = ixp_vis;

                    this.attachment.gattachment({
                        ixp: ixp_vis,
                        emptyMessage: "jres:32000613",   //RC 32000613 : Dokument je prázdný.
                        displayEngineOptions: {
                            pdfEngine: {
                                scrollMode: Gordic.Components.FilePreview.GPdfEngineScrollMode.Vertical
                            }
                        },
                    });
                }
                else {
                    console.log("Náhled se nepřekreslí, protože jsme na stejném řádku.");
                }
            }
            else {
                console.error("Id dokumentu nebo data řádku jsou prázdná.");
            }
        }

    }

}